module.exports = __webpack_public_path__ + "img/snowflake.150bc705.png";